export default "/images/arrow-right.svg?ec85a0b281d258eb63e1934a340576fd";